import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/bookingActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportCategoriesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchBookingCategories = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.B_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.bookingCategoriesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.b_fetchCategoriesSuccess(getParser(urls.bookingCategories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_fetchCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const postBookingCategory = category => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(category)
    }
    const { auth } = getState()

    securedFetch(urls.bookingCategories, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.b_saveCategoriesSuccess(json)))
        .then(() => toastr.success('Категория успешно сохранена'))
        .catch(
            handleError(
                dispatch,
                actions.b_saveCategoriesFailure,
                'Что-то пошло не так!',
                'При сохранении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteBookingCategory = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.bookingCategorySelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_deleteCategorySuccess(remoteId)))
        .then(() => toastr.success('Категория удалена'))
        .catch(
            handleError(
                dispatch,
                actions.b_deleteCategoryFailure,
                'Что-то пошло не так!',
                'При удалении категории произошла ошибка'
            )
        )
}

/** @thunk **/
export const importBookingCategories = () => (dispatch, getState) => {
    const { auth, bookingCurrentOrganization } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: bookingCurrentOrganization })
    }

    securedFetch(urls.reloadCategoriesFromBooking, auth, opts)
        .then(handleResponse)
        .then(showImportCategoriesToastr)
        .then(json => dispatch(actions.b_importCategoriesSuccess(getParser(urls.reloadCategoriesFromBooking)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_importCategoriesFailure,
                'Что-то пошло не так!',
                'При импорте категорий произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/bookingApi/bookingCategories.js